var React = require('react');

function Underline (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"underline-path","d":"M20.678,54.703C181.908,50.658 237.13,43.807 357.556,37.1C526.504,27.692 512.459,56.733 668.866,37.427C677.63,36.345 683.867,28.352 682.785,19.588C681.704,10.824 673.71,4.586 664.946,5.668C509.614,24.841 523.563,-4.194 355.777,5.15C235.699,11.837 180.638,18.679 19.875,22.713C11.047,22.935 4.06,30.282 4.281,39.11C4.503,47.938 11.85,54.925 20.678,54.703"}));
}

Underline.defaultProps = {"viewBox":"0 0 689 53"};

module.exports = Underline;

Underline.default = Underline;
